import React, { useState, useEffect } from "react";
import axios from 'axios'
import SiteFooterFourShape1 from "../../assets/images/shapes/site-footer-four-shape-1.png";
import Logo2 from "../../assets/images/resources/logo-2.png";
import AboutDetail3 from "../../assets/images/resources/about-detail3.jpg";
import CTAThreeBgShape from "../../assets/images/shapes/cta-three-bg-shape.png";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import TalentSyncLogo from "../../assets/images/talentSync_Logo.png";
import { useNavigate } from 'react-router-dom';
import "./Apply.css";



const ApplyForm = () => {
  const [formData, setFormData] = useState({
      name: '',
      email: '',
      whatsapp: '',
      usQuestion: '',
      effortQuestion: '',
      PaymentQuestion: '',
      state: '',
      message: ''
  });

  const handleChange = (e) => {
      const { name, value } = e.target;
      setFormData({
          ...formData,
          [name]: value
      });
  };
  // Inside your component function:
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // Prevent multiple submissions

    const { usQuestion, effortQuestion, PaymentQuestion } = formData;

    if (usQuestion === 'yes' && effortQuestion === 'yes' && PaymentQuestion === 'yes') {
        setIsSubmitting(true); // Start loading

        try {
            const response = await axios.post('https://9v4cvlbg6k.execute-api.eu-north-1.amazonaws.com/Prod/AutoRegister', formData);
            console.log('Response from first API:', response.data);

            alert('Application sent successfully!');
            setTimeout(() => {
              navigate('/dashboard/profile');
            }, 3000);
        } catch (error) {
            console.error('Error sending POST requests:', error);
            alert('Failed to send message!');
        } finally {
            setIsSubmitting(false); // Stop loading after request completes
        }
    } else {
        alert('You Must Agree to all Questions to Proceed.');
    }
  };



  const [open, setOpen] = React.useState(false);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  useEffect(() => {
    const talentSyncUser = JSON.parse(localStorage.getItem("TalentSyncUser"));
    if (talentSyncUser && talentSyncUser.name) {
      setFormData((prevState) => ({
        ...prevState,
        name: talentSyncUser.name,
        email: talentSyncUser.email,
      }));
    }
  }, []);

  const DrawerList = (
    <Box
      sx={{ width: 250, backgroundColor: "#040b1e", color: "white" }}
      role="presentation"
      onClick={toggleDrawer(false)}
    >
      <div
        style={{
          display: "flex ",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          height: "fit-content",
        }}
      >
        <img src={TalentSyncLogo} style={{ width: "55%" }} alt="logo"></img>
        <span
          className="mobile-nav__close mobile-nav__toggler"
          style={{ marginTop: "5%" }}
        >
          <i className="fa fa-times" onClick={toggleDrawer(false)}></i>
        </span>
      </div>
      <List>
        {/* Navigation Items */}
        <ListItem button component="a" href="/">
          <ListItemText
            primary="Home"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/about">
          <ListItemText
            primary="About"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/pricing">
          <ListItemText
            primary="Pricing"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/how-it-works">
          <ListItemText
            primary="How It Works"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
        <ListItem button component="a" href="/Apply">
          <ListItemText
            primary="Apply"
            sx={{ textAlign: "left", color: "white" }}
          />
        </ListItem>
        <Divider />
      </List>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: "20px",
          marginTop: "8%",
        }}
      >
        <a href="#" className="fab fa-twitter" style={{ color: "white" }}></a>
        <a
          href="#"
          className="fab fa-facebook-square"
          style={{ color: "white" }}
        ></a>
        <a
          href="#"
          className="fab fa-pinterest-p"
          style={{ color: "white" }}
        ></a>
        <a href="#" className="fab fa-instagram" style={{ color: "white" }}></a>
      </div>
    </Box>
  );
  return (
    <div>
      <div className="page-wrapper">
        <header className="main-header-four">
          <div className="main-header-four__top">
            <div className="container">
              <div className="main-header-four__top-inner">
                <div className="main-header-four__top-left">
                  <div className="main-header-four__logo">
                    {/* <!-- <a href="/"><img src="assets/images/resources/talentsync-logo.png" alt=""></a> --> */}
                    <a href="/">
                      <img src={TalentSyncLogo} style={{ width: "20%" }}></img>
                    </a>
                  </div>
                  {/* <!-- <div className="main-header-four__search-box">
                                <form action="#" className="main-header-four__search-form">
                                    <input type="search" placeholder="Search....">
                                    <button type="submit"><i className="icon-search"></i></button>
                                </form>
                            </div> --> */}
                </div>
                <ul className="list-unstyled main-header-four__contact-list">
                  <li>
                    <div className="text">
                      <span>email</span>
                      <p>
                        <a href="mailto:support@mail.talentsync.agency">
                          support@mail.talentsync.agency
                        </a>
                      </p>
                    </div>
                  </li>
                  {/* <!-- <li>
                                <div className="text">
                                    <span>PHONE</span>
                                    <p><a href="tel:18000000000">1800 000 0000 </a></p>
                                </div>
                            </li> --> */}
                </ul>
              </div>
            </div>
          </div>
          <nav className="main-menu main-menu-four">
            <div className="main-menu-four__wrapper">
              <div className="container">
                <div className="main-menu-four__wrapper-inner">
                  <div className="main-menu-four__left">
                    <div className="main-menu-four__main-menu-box">
                      <a className="mobile-nav__toggler">
                        <i
                          className="fa fa-bars"
                          onClick={toggleDrawer(true)}
                        ></i>
                      </a>
                      <Drawer
                        sx={{
                          "& .MuiDrawer-paper": {
                            backgroundColor: "#040b1e",
                            px: "15px",
                            py: "30px",
                          },
                        }}
                        open={open}
                        onClose={toggleDrawer(false)}
                      >
                        {DrawerList}
                      </Drawer>
                      <ul className="main-menu__list">
                        <li className="dropdown">
                          <a href="/">Home </a>
                        </li>
                        <li>
                          <a href="/dashboard/gmailtracker">Dashboard</a>
                        </li>
                        <li>
                          <a href="/about">About</a>
                        </li>

                        <li>
                          <a href="/pricing">Pricing</a>
                        </li>

                        <li>
                          <a href="/how-it-works">How It Works</a>
                        </li>
                        <li>
                          <a href="/apply">Apply</a>
                        </li>
                        <li>
                          <a href="/contact">Contact Us</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="main-menu-four__right">

                    {/* <div className="main-menu-four__btn-box">
                      <a
                        href="/contact"
                        className="main-menu-four__btn thm-btn"
                      >
                        GET A QUOTE
                      </a>
                    </div> */}
                    <div
                      className="main-menu-four__btn-box"
                      style={{ marginLeft: "10px" }}
                    >
                      <a href="/login" className="main-menu-four__btn thm-btn">
                        Log In
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </nav>
        </header>

        <div className="stricky-header stricked-menu main-menu main-menu-four">
          <div className="sticky-header__content"></div>
        </div>

        {/* <!--Page Header Start--> */}
        <section className="page-header">
          <div
            className="page-header__bg"
            style={{
              backgroundImage: `url(${AboutDetail3})`,
            }}
          ></div>
          <div className="container">
            <div className="page-header__inner">
              <h2>Apply</h2>
              <div className="thm-breadcrumb__box">
                <ul className="thm-breadcrumb list-unstyled">
                  <li>
                    <a href="/">Home</a>
                  </li>
                  <li>
                    <span>-</span>
                  </li>
                  <li>Apply</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        {/* <!--Page Header End--> */}

        {/* <!--Contact Page Start--> */}
        <section className="contact-page">
          <div className="container">
            <div className="contact-page__bottom">
              <div className="comment-form">
                <h3 className="comment-one__title">Let’s Work Together</h3>
                <br />
                <p className="comment-one__title">Alert: We Apply Only in the United States.</p>
                <p className="comment-one__title">The service is free. However, if you secure a job, you are required to pay 300 USD.</p>
                <br />

                <form onSubmit={handleSubmit} className="comment-one__form contact-form-validated" noValidate>
                    <div className="row">
                        <div className="col-xl-6 col-lg-6">
                            <div className="comment-form__input-box">
                                <input
                                    type="text"
                                    placeholder="Your Name*"
                                    name="name"
                                    value={formData.name}
                                    readOnly
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="comment-form__input-box">
                              <input
                                type="email"
                                placeholder="Your Email*"
                                name="email"
                                value={formData.email}
                                readOnly
                                required
                              />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-lg-6">
                            <div className="comment-form__input-box">
                                <input
                                    type="text"
                                    placeholder="Enter your WhatsApp Number With Your Country Code*"
                                    name="whatsapp"
                                    value={formData.whatsapp}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="comment-form__input-box">
                                <input
                                    type="text"
                                    placeholder="Enter your State*"
                                    name="state"
                                    value={formData.state}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-lg-6">
                          <div className="comment-form__input-box">
                              <select
                                  id="usQuestion"
                                  name="usQuestion"
                                  value={formData.usQuestion}
                                  onChange={handleChange}
                                  required
                              >
                                  <option value="" disabled selected>Only U.S. residents are allowed to register?*</option>
                                  <option value="yes">Yes, I live in the United States</option>
                                  <option value="WhatsApp">No, I live in the United States</option>
                              </select>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                          <div className="comment-form__input-box">
                              <select
                                  id="effortQuestion"
                                  name="effortQuestion"
                                  value={formData.effortQuestion}
                                  onChange={handleChange}
                                  required
                              >
                                  <option value="" disabled selected>Are you willing to respond to HR when they contact you?*</option>
                                  <option value="yes">Yes, I will open my email everyday</option>
                                  <option value="no">No, I will not open my email everyday</option>
                              </select>
                          </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-xl-6 col-lg-6">
                          <div className="comment-form__input-box">
                              <select
                                  id="PaymentQuestion"
                                  name="PaymentQuestion"
                                  value={formData.PaymentQuestion}
                                  onChange={handleChange}
                                  required
                              >
                                  <option value="" disabled selected>Are you willing to pay $300 if you secure a job?*</option>
                                  <option value="yes">Yes, I am willing to pay $300 if I secure a job. I understand that this is based on trust and honor, and I will fulfill my commitment.</option>
                                  <option value="no">No, I am not willing to pay $300 if I secure a job. I appreciate the offer</option>
                              </select>
                          </div>
                        </div>
                        <div className="col-xl-6 col-lg-6">
                            <div className="comment-form__input-box">
                                <input
                                    type="text"
                                    placeholder="Any comment you would like to share ? *"
                                    name="message"
                                    value={formData.message}
                                    onChange={handleChange}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="row">
 
                            <div className="comment-form__btn-box">
                              <button type="submit" className="thm-btn comment-form__btn" disabled={isSubmitting}>
                                  {isSubmitting ? "Submitting..." : "Apply"}
                              </button>
                            </div>
                    </div>
                </form>
                <div className="result"></div>
              </div>
            </div>
          </div>
        </section>
        {/* <!--Contact Page End--> */}

        {/* <!--CTA One Start --> */}

        {/* <!--CTA One End --> */}

        {/* <!--Site Footer Start--> */}
        
        
        <footer className="site-footer site-footer-three site-footer-four">
          <div className="site-footer__shape-1 float-bob-y">
            <img src={SiteFooterFourShape1} alt="" />
          </div>
          <div className="site-footer__top">
            <div className="container">
              <div className="site-footer__top-inner">
                <div className="row">
                  <div
                    className="col-xl-6 col-lg-6 col-md-6 wow fadeInUp"
                    data-wow-delay="100ms"
                  >
                    <div className="footer-widget__column footer-widget__about">
                      <div className="footer-widget__logo">
                        {/* <!-- <a href="/"><img src="assets/images/resources/footer-logo-4.png"
                                                alt=""></a> --> */}
                        <a href="/">
                          <h2 style={{ color: "white" }}>Talentsync</h2>
                        </a>
                      </div>
                      <p className="footer-widget__about-text">
                        Get Noticed by Employers: TalentSync Finds You the
                        Perfect Job
                      </p>
                      <div className="footer-widget__emergency-call">
                        <a href="mailto:support@mail.talentsync.com">
                         support@mail.talentsync.com
                        </a>
                      </div>
                      {/*
                      <div className="footer-widget__social">
                        <a href="#">
                          <span className="icon-facebook"></span>
                        </a>
                        <a href="#">
                          <span className="icon-instagram-1"></span>
                        </a>
                        <a href="#">
                          <span className="icon-tik-tok"></span>
                        </a>
                        <a href="#">
                          <span className="icon-youtube"></span>
                        </a>
                      </div>
                      */}
                    </div>
                  </div>
                  <div
                    className="col-xl-6 col-lg-6 col-md-6 wow fadeInUp"
                    data-wow-delay="200ms"
                  >
                    <div className="footer-widget__column footer-widget__navigation">
                      <div className="footer-widget__title-box">
                        <h3 className="footer-widget__title">Navigation</h3>
                      </div>
                      <ul className="footer-widget__navigation-list list-unstyled">
                        <li>
                          <a href="/">Home</a>
                        </li>
                        <li>
                          <a href="/about">About Us</a>
                        </li>
                        <li>
                          <a href="/how-it-works">How It Works</a>
                        </li>
                        <li>
                          <a href="/pricing">Pricing</a>
                        </li>
                        <li>
                          <a href="/apply">Apply</a>
                        </li>
                        <li>
                          <a href="/contact">Contact Us</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="site-footer__bottom">
            <div className="container">
              <div className="site-footer__bottom-inner">
                <p className="site-footer__bottom-text">
                  <a href="/PrivacyPolicy">Privacy Policy</a> &nbsp;|&nbsp; Copyright © 2024 Talentsync.Agency. All Rights Reserved
                </p>
              </div>
            </div>
          </div>
        </footer>


        {/* <!--Site Footer End--> */}
      </div>

      <div className="mobile-nav__wrapper">
        <div className="mobile-nav__overlay mobile-nav__toggler"></div>
        {/* <!-- /.mobile-nav__overlay --> */}
        <div className="mobile-nav__content">
          <span className="mobile-nav__close mobile-nav__toggler">
            <i className="fa fa-times"></i>
          </span>

          <div className="logo-box">
            <a href="/" aria-label="logo image">
              <img src={Logo2} width="150" alt="" />
            </a>
          </div>
          {/* <!-- /.logo-box --> */}
          <div className="mobile-nav__container"></div>
          {/* <!-- /.mobile-nav__container --> */}

          <ul className="mobile-nav__contact list-unstyled">
            <li>
              <i className="fa fa-envelope"></i>
              <a href="mailto:needhelp@packageName__.com">
                needhelp@sonchoy.com
              </a>
            </li>
            <li>
              <i className="fa fa-phone-alt"></i>
              <a href="tel:666-888-0000">666 888 0000</a>
            </li>
          </ul>

        </div>
        {/* <!-- /.mobile-nav__content --> */}
      </div>
      {/* <!-- /.mobile-nav__wrapper --> */}

      <div className="search-popup">
        <div className="search-popup__overlay search-toggler"></div>
        {/* <!-- /.search-popup__overlay --> */}
        <div className="search-popup__content">
          <form action="#">
            <label for="search" className="sr-only">
              search here
            </label>
            <input type="text" id="search" placeholder="Search Here..." />
            <button
              type="submit"
              aria-label="search submit"
              className="thm-btn"
            >
              <i className="fas fa-search"></i>
            </button>
          </form>
        </div>
        {/* <!-- /.search-popup__content --> */}
      </div>
      {/* <!-- /.search-popup --> */}

      <a href="#" data-target="html" className="scroll-to-target scroll-to-top">
        <i className="fas fa-arrow-up"></i>
      </a>
    </div>
  );
};

export default ApplyForm;
